import * as actions from './actions'
import * as getters from './getters'
import * as mutations from './mutations'

export default {
  state: {
    list: {
      'forms': {
        'id': '',
        'contact_button_text': '',
        'contact_button_icon': '',
        'contact_button_icon_id': '',
        'contact_button_id': ''
      },
      'detail': [],
      'button_list': [
        {'id': '', 'text': '', 'icon': ''}
      ]
    },
    limit: {
      option: 500,
      option_character: 100,
      option_checkbox_radio: 10,
      placeholder: 100
    }
  },
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/contact_forms/index.js